export function formatRates(raw: string) {
    return raw.split('\n')[0].split('.').join(',')
}
